<template>
  <!-- 본문 -->
  <div class="conRight">
    <!-- conHeader -->
    <div class="conHeader">
      <ul class="conHeaderCate">
        <li>전자입찰</li>
        <li>입찰계획 등록</li>
      </ul>
    </div>
    <!-- //conHeader -->
    <!-- contents -->
    <div class="contents">
      <div class="formWidth">
        <h3 class="h3Tit">입찰기본정보</h3>
        <div class="boxSt mt20">
          <div class="flex align-items-center">
            <div class="formTit flex-shrink0 width170px">입찰번호</div>
            <div class="width100">
              <a
              @click.prevent="$refs.bidPast.initModal()"
                data-toggle="modal"
                data-target="#bidPast"
                class="btnStyle btnOutlineBlue"
                title="과거입찰 가져오기"
                style="margin-left:0px"
                >과거입찰 가져오기</a
              >
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="formTit flex-shrink0 width170px">
              입찰명 <span class="star">*</span>
            </div>
            <div class="width100">
              <input
                type="text"
                name=""
                id=""
                class="inputStyle"
                placeholder=""
                v-model="bidContent.biName"
                maxlength="50"
              />
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="formTit flex-shrink0 width170px">
              품목 <span class="star">*</span>
            </div>
            <div class="flex align-items-center width100">
              <input
                type="text"
                name=""
                id=""
                class="inputStyle"
                placeholder=""
                v-model="bidContent.itemName"
                @input="bidContent.itemCode = $event.target.value"
                disabled
              />
              <a
                class="btnStyle btnSecondary ml10"
                title="조회"
                @click="
                  itemPop = 'custType1';
                  $refs.itemPop.initModal();
                "
                data-toggle="modal"
                data-target="#itemPop"
                >조회</a
              >
            </div>
          </div>
          <div class="flex align-items-center mt20">
            <div class="formTit flex-shrink0 width170px">
              입찰방식 <span class="star">*</span>
            </div>
            <div class="width100">
              <input
                type="radio"
                name="bm1"
                value="A"
                id="bm1_1"
                class="radioStyle"
                checked="true"
                v-model="bidContent.biModeCode"
                v-bind:data-target="
                  bidContent.biModeCode === 'B' ? '#bmGeneral' : ''
                "
              /><label for="bm1_1">지명경쟁입찰</label>
              <input
                type="radio"
                name="bm1"
                value="B"
                id="bm1_2"
                class="radioStyle"
                v-model="bidContent.biModeCode"
                data-toggle="modal"
                v-bind:data-target="
                  bidContent.biModeCode === 'A' ? '#bmGeneral' : ''
                "
              /><label for="bm1_2">일반경쟁입찰</label>
            </div>
          </div>
          <div class="flex align-items-center mt20">
            <div class="formTit flex-shrink0 width170px">
              입찰참가자격 <span class="star">*</span>
            </div>
            <div class="width100">
              <input
                type="text"
                name=""
                id=""
                class="inputStyle"
                placeholder=""
                v-model="bidContent.bidJoinSpec"
                maxlength="100"
              />
            </div>
          </div>
          <div class="flex mt20">
            <div class="formTit flex-shrink0 width170px">특수조건</div>
            <div class="width100">
              <textarea
                class="textareaStyle boxOverflowY"
                onkeydown="resize(this)"
                onkeyup="resize(this)"
                placeholder=""
                v-model="bidContent.specialCond"
                @input="limitText"
              ></textarea>
            </div>
          </div>
          <div class="flex align-items-center mt20">
            <div class="formTit flex-shrink0 width170px">
              현장설명일시 <span class="star">*</span>
            </div>
            <div class="flex align-items-center width100">
              <Calendar @update-date="fnUpdateSpotDate" calendarId="spotDate" classProps="datepicker inputStyle maxWidth140px" :initDate="datePart" :minDate="minDate"></Calendar>
              <!-- <input
                type="time"
                class="inputStyle maxWidth140px"
                v-model="timePart"
              /> -->
              <select class="inputStyle ml10" v-model="timePart" style="background:url('../images/selectArw.png') no-repeat right 15px center;max-width: 110px">
                  <option value="">시간 선택</option>
                  <option value="01:00">01:00</option>
                  <option value="02:00">02:00</option>
                  <option value="03:00">03:00</option>
                  <option value="04:00">04:00</option>
                  <option value="05:00">05:00</option>
                  <option value="06:00">06:00</option>
                  <option value="07:00">07:00</option>
                  <option value="08:00">08:00</option>
                  <option value="09:00">09:00</option>
                  <option value="10:00">10:00</option>
                  <option value="11:00">11:00</option>
                  <option value="12:00">12:00</option>
                  <option value="13:00">13:00</option>
                  <option value="14:00">14:00</option>
                  <option value="15:00">15:00</option>
                  <option value="16:00">16:00</option>
                  <option value="17:00">17:00</option>
                  <option value="18:00">18:00</option>
                  <option value="19:00">19:00</option>
                  <option value="20:00">20:00</option>
                  <option value="21:00">21:00</option>
                  <option value="22:00">22:00</option>
                  <option value="23:00">23:00</option>
              </select>
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="formTit flex-shrink0 width170px">
              현장설명장소 <span class="star">*</span>
            </div>
            <div class="width100">
              <input
                type="text"
                name=""
                id=""
                class="inputStyle"
                placeholder=""
                v-model="bidContent.spotArea"
                maxlength="80"
              />
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="formTit flex-shrink0 width170px">
              낙찰자결정방법 <span class="star">*</span>
            </div>
            <div class="width100">
              <select
                name=""
                class="selectStyle maxWidth200px"
                v-model="bidContent.succDeciMethCode"
              >
                <option value="1">최저가</option>
                <option value="2">최고가</option>
                <option value="3">내부적격심사</option>
                <option value="4">최고가&내부적격심사</option>
                <option value="5">최저가&내부적격심사</option>
              </select>
            </div>
          </div>
          <div class="flex align-items-center mt20" v-if="bidContent.biModeCode==='A'">
            <div class="formTit flex-shrink0 width170px">
              입찰참가업체 <span class="star">*</span>
            </div>
            <div class="flex align-items-center width100">
              <div class="overflow-y-scroll boxStSm width100" style="display: inline">
                <a v-if="custContent.length ===0"
                    >선택된 참가업체 없음</a>
                <div  v-for="(val, idx) in custContent" :key="idx">   
                  
                <a
                    @click.prevent="openCustUserDetailPop(val.custCode)"
                    class="textUnderline"
                    >{{ val.custName }}</a
                  >
                  <span v-for="(data,idx) in custUserName" :key="idx">{{ val.custCode == data.custCode ? ` ${data.userName}` : '' }}</span>
                  <i class="fa-regular fa-xmark textHighlight ml5" @click="removeCust(idx,val.custCode)"></i></a>
                  <!-- <span v-if="idx !== custContent.length - 1">, </span> -->
                </div>
                </div>
              <a
                data-toggle="modal"
                data-target="#custPop"
                class="btnStyle btnSecondary ml10"
                title="업체선택"
                @click="$refs.custPop.initModal();"
                >업체선택</a
              >
            </div>
          </div>
          <div class="flex align-items-center mt20" v-if="bidContent.biModeCode==='B'">
            <div class="formTit flex-shrink0 width170px">입찰참가업체</div>
            <div class="flex align-items-center width100">
              <div
                class="overflow-y-scroll boxStSm width100"
                style="height: 50px"
              >
                <a>가입회원사 전체</a>
              </div>
            </div>
          </div>
          <div class="flex align-items-center mt20">
            <div class="formTit flex-shrink0 width170px">
              금액기준 <span class="star">*</span>
            </div>
            <div class="width100">
              <input
                type="text"
                name=""
                id=""
                class="inputStyle"
                placeholder=""
                v-model="bidContent.amtBasis"
                maxlength="100"
              />
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="formTit flex-shrink0 width170px">결제조건</div>
            <div class="width100">
              <input
                type="text"
                name=""
                id=""
                class="inputStyle"
                placeholder=""
                v-model="bidContent.payCond"
                maxlength="50"
              />
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="formTit flex-shrink0 width170px">예산금액</div>
            <div class="flex align-items-center width100">
              <input
                type="text"
                name=""
                id=""
                class="inputStyle maxWidth200px"
                placeholder=""
                v-model="bdAmt"
              />
              <div class="ml10">원</div>
            </div>
          </div>
          <div class="flex align-items-center mt20">
            <div class="formTit flex-shrink0 width170px">입찰담당자</div>
            <div class="width100">{{ bidContent.createUserName }}</div>
          </div>
        </div>

        <h3 class="h3Tit mt50" v-if="bidContent.interrelatedCustCode==='02'">입찰분류</h3>
        <div class="boxSt mt20" v-if="bidContent.interrelatedCustCode==='02'">
          <div class="flex align-items-center">
            <div class="formTit flex-shrink0 width170px">
              분류군 <span class="star">*</span>
            </div>
            <div class="flex align-items-center width100">
              <select name="" class="selectStyle" v-model="bidContent.matDept">
                <option value=null>사업부를 선택 하세요.</option>
                <option v-for="(dept,idx) in lotteDeptList" :value="dept.codeVal" :key="idx">{{ dept.codeName }}</option>
              </select>
              <select name="" class="selectStyle" style="margin: 0 10px" v-model="bidContent.matProc">
                <option value=null>공정을 선택 하세요.</option>
                <option v-for="(proc,idx) in lotteProcList" :value="proc.codeVal" :key="idx">{{ proc.codeName }}</option>
              </select>
              <select name="" class="selectStyle" v-model="bidContent.matCls">
                <option value=null>분류를 선택 하세요.</option>
                <option v-for="(cls,idx) in lotteClsList" :value="cls.codeVal" :key="idx">{{ cls.codeName }}</option>
              </select>
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="formTit flex-shrink0 width170px">공장동</div>
            <div class="width100">
              <input
                type="text"
                name=""
                id=""
                class="inputStyle"
                placeholder=""
                v-model="bidContent.matFactory"
                maxlength="50"
              />
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="flex align-items-center width100">
              <div class="formTit flex-shrink0 width170px">라인</div>
              <div class="width100">
                <input
                  type="text"
                  name=""
                  id=""
                  class="inputStyle"
                  placeholder=""
                  v-model="bidContent.matFactoryLine"
                  maxlength="25"
                />
              </div>
            </div>
            <div class="flex align-items-center width100 ml80">
              <div class="formTit flex-shrink0 width170px">호기</div>
              <div class="width100">
                <input
                  type="text"
                  name=""
                  id=""
                  class="inputStyle"
                  placeholder=""
                  v-model="bidContent.matFactoryCnt"
                  maxlength="25"
                />
              </div>
            </div>
          </div>
        </div>

        <h3 class="h3Tit mt50">입찰공고 추가등록 사항</h3>
        <div class="boxSt mt20">
          <div class="flex align-items-center">
            <div class="flex align-items-center width100">
              <div class="formTit flex-shrink0 width170px">
                제출시작일시 <span class="star">*</span>
              </div>
              <div class="flex align-items-center width100">
                <Calendar @update-date="fnUpdateStartDate" calendarId="startDate" classProps="datepicker inputStyle" :initDate="datePart1" :minDate="minDate"></Calendar>
                <!-- <input type="time" class="inputStyle ml10" v-model="timePart1"/> -->
                <select class="inputStyle ml10" v-model="timePart1" style="background:url('../images/selectArw.png') no-repeat right 15px center;max-width: 110px">
                  <option value="">시간 선택</option>
                  <option value="01:00">01:00</option>
                  <option value="02:00">02:00</option>
                  <option value="03:00">03:00</option>
                  <option value="04:00">04:00</option>
                  <option value="05:00">05:00</option>
                  <option value="06:00">06:00</option>
                  <option value="07:00">07:00</option>
                  <option value="08:00">08:00</option>
                  <option value="09:00">09:00</option>
                  <option value="10:00">10:00</option>
                  <option value="11:00">11:00</option>
                  <option value="12:00">12:00</option>
                  <option value="13:00">13:00</option>
                  <option value="14:00">14:00</option>
                  <option value="15:00">15:00</option>
                  <option value="16:00">16:00</option>
                  <option value="17:00">17:00</option>
                  <option value="18:00">18:00</option>
                  <option value="19:00">19:00</option>
                  <option value="20:00">20:00</option>
                  <option value="21:00">21:00</option>
                  <option value="22:00">22:00</option>
                  <option value="23:00">23:00</option>
              </select>
              </div>
            </div>
            <div class="flex align-items-center width100 ml80">
              <div class="formTit flex-shrink0 width170px">
                제출마감일시 <span class="star">*</span>
              </div>
              <div class="flex align-items-center width100">
                <Calendar @update-date="fnUpdateCloseDate" calendarId="closeDate" classProps="datepicker inputStyle" :initDate="datePart2" :minDate="minDate"></Calendar>
                <!-- <input type="time" class="inputStyle ml10" v-model="timePart2"/> -->
                <select class="inputStyle ml10" v-model="timePart2" style="background:url('../images/selectArw.png') no-repeat right 15px center;max-width: 110px">
                  <option value="">시간 선택</option>
                  <option value="01:00">01:00</option>
                  <option value="02:00">02:00</option>
                  <option value="03:00">03:00</option>
                  <option value="04:00">04:00</option>
                  <option value="05:00">05:00</option>
                  <option value="06:00">06:00</option>
                  <option value="07:00">07:00</option>
                  <option value="08:00">08:00</option>
                  <option value="09:00">09:00</option>
                  <option value="10:00">10:00</option>
                  <option value="11:00">11:00</option>
                  <option value="12:00">12:00</option>
                  <option value="13:00">13:00</option>
                  <option value="14:00">14:00</option>
                  <option value="15:00">15:00</option>
                  <option value="16:00">16:00</option>
                  <option value="17:00">17:00</option>
                  <option value="18:00">18:00</option>
                  <option value="19:00">19:00</option>
                  <option value="20:00">20:00</option>
                  <option value="21:00">21:00</option>
                  <option value="22:00">22:00</option>
                  <option value="23:00">23:00</option>
              </select>
              </div>
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="flex align-items-center width100">
              <div class="formTit flex-shrink0 width170px">개찰자 <span class="star">*</span></div>
              <div class="flex align-items-center width100">
                <input
                  type="text"
                  name=""
                  id=""
                  class="inputStyle"
                  placeholder=""
                  v-model="bidContent.estOpener"
                  disabled
                />
                <a
                  data-toggle="modal"
                  data-target="#bidOpenUserPop"
                  class="btnStyle btnSecondary ml10"
                  title="선택"
                  @click="$refs.bidOpenUserPop.initModal(bidContent.interrelatedCustCode);"
                  >선택</a
                >
              </div>
            </div>
            <div class="flex align-items-center width100 ml80">
              <div class="formTit flex-shrink0 width170px">입찰공고자 <span class="star">*</span></div>
              <div class="flex align-items-center width100">
                <input
                  type="text"
                  name=""
                  id=""
                  class="inputStyle"
                  placeholder=""
                  v-model="bidContent.gongoId"
                  disabled
                />
                <a
                  data-toggle="modal"
                  data-target="#bidUserPop"
                  class="btnStyle btnSecondary ml10"
                  title="선택"
                  @click="$refs.bidUserPop.initModal('gongoId', bidContent.interrelatedCustCode);"
                  >선택</a
                >
              </div>
            </div>
          </div>
           <div class="flex align-items-center mt10">
            <div class="flex align-items-center width100">
              <div class="formTit flex-shrink0 width170px">낙찰자 <span class="star">*</span></div>
              <div class="flex align-items-center width100">
                <input
                  type="text"
                  name=""
                  id=""
                  class="inputStyle"
                  placeholder=""
                  v-model="bidContent.estBidder"
                  disabled
                />
                <a
                  data-toggle="modal"
                  data-target="#biddingUserPop"
                  class="btnStyle btnSecondary ml10"
                  title="선택"
                  @click="$refs.biddingUserPop.initModal(bidContent.interrelatedCustCode);"
                  >선택</a
                >
              </div>
            </div>
            <div class="flex align-items-center width100 ml80">
              <div class="formTit flex-shrink0 width170px" style="display: none;"></div>
              <div class="flex align-items-center width100">
                <input
                  type="text"
                  name=""
                  id=""
                  class="inputStyle"
                  placeholder=""
                  disabled
                  style="display: none;"
                />
                <a
                  class="btnStyle btnSecondary ml10"
                  title="선택"
                  style="display: none;"
                  >선택</a
                >
              </div>
            </div>
            </div>
          <div class="flex align-items-center mt10">
            <div class="flex align-items-center width100">
              <div class="formTit flex-shrink0 width170px">입회자1</div>
              <div class="flex align-items-center width100">
                <input
                  type="text"
                  name=""
                  id=""
                  class="inputStyle"
                  placeholder=""
                  v-model="bidContent.openAtt1"
                 :style="{ 'margin-right': bidContent.openAtt1Code ? '5px' : '0' }"
                  disabled
                />
                <i v-if="bidContent.openAtt1Code" @click="removeOpenAttCode('1')" class="fa-regular fa-xmark textHighlight ml5"></i></a>
                <a
                  data-toggle="modal"
                  data-target="#bidUserPop"
                  class="btnStyle btnSecondary ml10"
                  title="선택"
                  @click="$refs.bidUserPop.initModal('openAtt1', bidContent.interrelatedCustCode);"
                  >선택</a
                >
              </div>
            </div>
            <div class="flex align-items-center width100 ml80">
              <div class="formTit flex-shrink0 width170px">입회자2</div>
              <div class="flex align-items-center width100">
                <input
                  type="text"
                  name=""
                  id=""
                  class="inputStyle"
                  placeholder=""
                  v-model="bidContent.openAtt2"
                  :style="{ 'margin-right': bidContent.openAtt2Code ? '5px' : '0' }"
                  disabled
                />
                <i v-if="bidContent.openAtt2Code" @click="removeOpenAttCode('2')" class="fa-regular fa-xmark textHighlight ml5"></i></a>
                <a
                  data-toggle="modal"
                  data-target="#bidUserPop"
                  class="btnStyle btnSecondary ml10"
                  title="선택"
                  @click="$refs.bidUserPop.initModal('openAtt2', bidContent.interrelatedCustCode);"
                  >선택</a
                >
              </div>
            </div>
          </div>
          <div class="flex align-items-center mt10">
            <div class="flex align-items-center width100">
              <div class="formTit flex-shrink0 width170px">
                내역방식 <span class="star">*</span>
              </div>
              <div class="width100">
                <input
                  type="radio"
                  name="bm2"
                  value="1"
                  id="bm2_1"
                  class="radioStyle"
                  checked=""
                  v-model="bidContent.insModeCode"
                  data-toggle="modal"
                  v-bind:data-target="bidContent.insModeCode === '2' ? '#bmFile' : ''"
                /><label for="bm2_1">파일등록</label>
                <input
                  type="radio"
                  name="bm2"
                  value="2"
                  id="bm2_2"
                  class="radioStyle"
                  v-model="bidContent.insModeCode"
                  data-toggle="modal"
                  v-bind:data-target="bidContent.insModeCode === '1' ? '#bmFile' : ''"
                  @click="initDetailFile"
                /><label for="bm2_2">내역직접등록</label>
              </div>
            </div>
            <div class="flex align-items-center width100 ml80">
              <div class="formTit flex-shrink0 width170px">납품조건 <span class="star">*</span></div>
              <div class="width100">
                <input
                  type="text"
                  name=""
                  id=""
                  class="inputStyle"
                  placeholder=""
                  v-model="bidContent.supplyCond"
                />
              </div>
            </div>
          </div>
          <div class="flex mt10" v-show="bidContent.insModeCode==='2'">
            <div class="formTit flex-shrink0 width170px">
              세부내역 <span class="star">*</span
              ><a
                class="btnStyle btnSecondary ml10"
                title="추가"
                @click="addEmptyRow"
                >추가</a
              >
            </div>
            <div class="width100">
              <table class="tblSkin1">
                <colgroup>
                  <col style="" />
                </colgroup>
                <thead>
                  <tr>
                    <th>품목명</th>
                    <th>규격</th>
                    <th>단위</th>
                    <th>예정단가</th>
                    <th>수량</th>
                    <th>합계</th>
                    <th class="end">삭제</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(val, idx) in tableContent" :key="idx">
                    <td>
                      <input
                        type="text"
                        name=""
                        id=""
                        class="inputStyle inputSm"
                        placeholder=""
                        v-model.trim="val.name"
                        maxlength="100"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name=""
                        id=""
                        class="inputStyle inputSm"
                        placeholder=""
                        v-model.trim="val.ssize"
                        maxlength="25"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name=""
                        id=""
                        class="inputStyle inputSm"
                        placeholder=""
                        v-model.trim="val.unitcode"
                        maxlength="25"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name=""
                        id=""
                        class="inputStyle inputSm text-right"
                        placeholder=""
                        v-model.trim="val.orderUc"
                        maxlength="15"
                        @input="changeNumOrderUc(idx)"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name=""
                        id=""
                        class="inputStyle inputSm text-right"
                        placeholder=""
                        v-model.trim="val.orderQty"
                        maxlength="15"
                        @input="changeNumOrderQty(idx)"
                      />
                    </td>
                    <td class="text-right">{{ (Number(val.orderQty.replace(/,/g, '')) * Number(val.orderUc.replace(/,/g, '')) ).toLocaleString() }}</td>
                    <td class="text-right end">
                      <a
                        class="btnStyle btnSecondary btnSm"
                        title="삭제"
                        @click="deleteRow(idx)"
                        >삭제</a
                      >
                    </td>
                   </tr>
                </tbody>
              </table>
              <p class="text-right mt10">
                <strong>총합계 : {{ totalSum | numberWithCommas }}</strong>
              </p>
            </div>
          </div>
          <div class="flex mt10" v-show="bidContent.insModeCode==='1'">
            <div class="formTit flex-shrink0 width170px">
              세부내역 <span class="star">*</span>
              <!-- 툴팁 -->
              <i class="fas fa-question-circle toolTipSt ml5">
                <div class="toolTipText" style="width: 370px">
                  <ul class="dList">
                    <li>
                      <div>
                        내역방식이 파일등록 일 경우 필수로 파일을 등록해야
                        합니다.
                      </div>
                    </li>
                    <li>
                      <div>파일이 암호화 되어 있는지 확인해 주십시오</div>
                    </li>
                  </ul>
                </div>
              </i>
              <!-- //툴팁 -->
            </div>
            <div class="width100">
              <!-- 다중파일 업로드 -->
              <div class="upload-boxWrap">
                <div class="upload-box" v-if="!insFile">
                  <input type="file" id="file-input" @change="fileInputChangeInsFile"/>
                  <div class="uploadTxt">
                    <i class="fa-regular fa-upload"></i>
                    <div>
                      클릭 혹은 파일을 이곳에 드롭하세요.(암호화 해제)<br>파일
                      최대 10MB (등록 파일 개수 최대 1개)
                    </div>
                  </div>
                </div>
                <div class="uploadPreview" id="preview" v-if="insFile"><p style="line-height:80px;">{{ insFile.name }}<button class="file-remove" @click="insFile = ''">삭제</button></p></div>
              </div>
              <!-- //다중파일 업로드 -->
            </div>
          </div>
          <div class="flex mt10">
            <div class="formTit flex-shrink0 width170px">
              첨부파일(대내용)
              <!-- 툴팁 -->
              <i class="fas fa-question-circle toolTipSt ml5">
                <div class="toolTipText" style="width: 320px">
                  <ul class="dList">
                    <li>
                      <div>
                        그룹사 내부 입찰관계자가 확인하는 첨부파일 입니다.
                      </div>
                    </li>
                    <li>
                      <div>파일이 암호화 되어 있는지 확인해 주십시오</div>
                    </li>
                  </ul>
                </div>
              </i>
              <!-- //툴팁 -->
              <a
                class="modalBtnCheck"
                title="파일 추가(대내용)"
                @click="innerFilesPop"
                style="margin-left: 0;margin-right:0;margin-top:5px"
                >파일 추가(대내용)
                </a
              >
            </div>
              <!-- 다중파일 업로드 -->
            <input type="file" ref="innerFilesInput" @input="innerFilesClick" multiple style="display: none">
            <div class="width100"
              @dragover.prevent
              @dragenter.prevent
              @dragleave.prevent
              @drop.prevent="innerFilesHandleDrop"
              @click="innerFilesPop"
              :style="{ cursor: innerFiles.length == 0 ? 'pointer' : '' }"
              v-show="innerFiles.length == 0 "
            >
              <div class="upload-boxWrap" style="min-height: 80px;max-height:150px;overflow:auto">
                <div class="upload-box">
                  <div class="uploadTxt">
                    <i class="fa-regular fa-upload"></i>
                    <div>
                      클릭 혹은 파일을 이곳에 드롭하세요.(암호화 해제)<br />파일
                      최대 10MB (등록 파일 개수 최대 20개)
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="width100" 
              @dragover.prevent
              @dragenter.prevent
              @dragleave.prevent
              @drop.prevent="innerFilesHandleDrop"
              v-show="innerFiles.length > 0 ">
              <div class="upload-boxWrap" style="min-height: 80px;max-height:190px;overflow:auto">
                <div class="uploadPreview" id="preview2" v-for="(data,idx) in innerFiles" :key="idx">
                  <p v-if="idx == 0" style="line-height:20px;"> 파일 개수 : {{innerFiles.length }}개<button v-if="idx == 0"  class="file-remove" @click="removeInnerFiles('ALL')" style="padding-left: 10px;padding-right: 10px;">전체 삭제</button></p>
                    <p style="line-height:40px;">{{ data.name }}
                    <button class="file-remove" @click="removeInnerFiles(idx)">삭제</button>
                </p>
                </div>
              </div>
            </div>

          </div>
          <div class="flex mt10">
            <div class="formTit flex-shrink0 width170px">
              첨부파일(대외용)
              <!-- 툴팁 -->
              <i class="fas fa-question-circle toolTipSt ml5">
                <div class="toolTipText" style="width: 300px">
                  <ul class="dList">
                    <li>
                      <div>입찰 참가업체들이 확인하는 첨부파일 입니다.</div>
                    </li>
                    <li>
                      <div>파일이 암호화 되어 있는지 확인해 주십시오</div>
                    </li>
                  </ul>
                </div>
              </i>
              <!-- //툴팁 -->
              <a
                class="modalBtnCheck"
                title="파일 추가(대외용)"
                style="margin-left: 0;margin-right:0;margin-top:5px"
                @click="outerFilesPop"
                >파일 추가(대외용)
                </a
              >
            </div>
            <input type="file" ref="outerFilesInput" @input="outerFilesClick" multiple style="display: none">

            <div class="width100"
              @dragover.prevent
              @dragenter.prevent
              @dragleave.prevent
              @drop.prevent="outerFilesHandleDrop"
              @click="outerFilesPop"
              :style="{ cursor: outerFiles.length == 0 ? 'pointer' : '' }"
              v-show="outerFiles.length == 0"
            >
              <div class="upload-boxWrap" style="min-height: 80px;max-height:150px;overflow:auto">
                <div class="upload-box">
                  <div class="uploadTxt">
                    <i class="fa-regular fa-upload"></i>
                    <div>
                      클릭 혹은 파일을 이곳에 드롭하세요.(암호화 해제)<br />파일
                      최대 10MB (등록 파일 개수 최대 20개)
                    </div>
                  </div>
                </div>          
              </div>
            </div>

            <div class="width100" 
              @dragover.prevent
              @dragenter.prevent
              @dragleave.prevent
              @drop.prevent="outerFilesHandleDrop"
              v-show="outerFiles.length >0">
              <div class="upload-boxWrap" style="min-height: 80px;max-height:190px;overflow:auto">
                <div class="uploadPreview" id="preview2" v-for="(data,idx) in outerFiles" :key="idx">
                  <p v-if="idx == 0" style="line-height:20px;"> 파일 개수 : {{outerFiles.length }}개 <button v-if="idx == 0" class="file-remove" @click="removeOuterFiles('ALL')" style="padding-left: 10px;padding-right: 10px;">전체 삭제</button></p>
                  <p style="line-height:40px;">{{ data.name }}
                  <button class="file-remove" @click="removeOuterFiles(idx)">삭제</button>
                </p>
                </div>              
              </div>
            </div>
              <!-- 다중파일 업로드 -->
          </div>

        </div>

        <div class="text-center mt50">
          <a
            class="btnStyle btnOutline"
            title="목록"
            @click="movetolist"
            >목록 </a
          >
          <a
            data-toggle="modal"
            @click="openConfirm"
            class="btnStyle btnPrimary"
            title="저장"
            >저장</a
          >
        </div>
      </div>
    </div>
    <!-- //contents -->

    <!-- 일반경쟁입찰 -->
    <div
      class="modal fade modalStyle"
      id="bmGeneral"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" style="width: 100%; max-width: 420px">
        <div class="modal-content">
          <div class="modal-body">
            <a class="ModalClose" data-dismiss="modal" title="닫기"
              ><i class="fa-solid fa-xmark" @click="selectBid('named')"></i
            ></a>
            <div class="alertText2">
              일반경쟁입찰을 선택하면 입찰은 등록되어 있는 모든 협력업체를
              대상으로 하고 참가업체가 선택되어 있다면 초기화 됩니다.<br /><br />일반경쟁입찰을
              선택 하시겠습니까?
            </div>
            <div class="modalFooter">
              <a
                class="modalBtnClose"
                data-dismiss="modal"
                title="취소"
                @click="selectBid('cancel')"
                >취소</a
              >
              <a
                class="modalBtnCheck"
                data-toggle="modal"
                title="선택"
                @click="selectBid('ok')"
                >선택</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //일반경쟁입찰 -->
        <!-- 파일등록 -->
    <div
      class="modal fade modalStyle"
      id="bmFile"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      
    >
      <div class="modal-dialog" style="width: 100%; max-width: 420px" >
        <div class="modal-content" >
          <div class="modal-body">
            <a
              class="ModalClose"
              data-dismiss="modal"
              title="닫기"
              ><i class="fa-solid fa-xmark"></i
            ></a>
            <div class="alertText2">
              내역방식을 변경하면 이전에 선택한
              세부내역이 초기화됩니다.
              변경 하시겠습니까?
            </div>
            <div class="modalFooter">
              <a
                class="modalBtnClose"
                data-dismiss="modal"
                title="취소"
                @click="selectIns('cancel')"
                >취소</a
              >
              <a
                class="modalBtnCheck"
                data-toggle="modal"
                title="선택"
                @click="selectIns('ok')"
                >선택</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //파일등록 -->


        		<!-- 입찰계획 저장 -->
		<div class="modal fade modalStyle" id="save" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" style="width:100%; max-width:420px">
				<div class="modal-content">
					<div class="modal-body">
						<a  class="ModalClose" data-dismiss="modal" title="닫기"><i class="fa-solid fa-xmark"></i></a>
						<div class="alertText2">작성하신 내용으로 입찰계획을<br>등록합니다.<br>등록 하시겠습니까?</div>
						<div class="modalFooter">
							<a  class="modalBtnClose" data-dismiss="modal" title="취소">취소</a>
							<a  @click="save" class="modalBtnCheck" data-toggle="modal" title="저장">저장</a>
						</div>
					</div>				
				</div>
			</div>
		</div>
		<!-- //입찰계획 저장 -->

    <!-- 과거입찰내역 -->
    <bid-past ref="bidPast" @callbackFunc="callbackPastBid" />
    <!-- 품목 조회 -->
    <item-pop ref="itemPop" @callbackFunc="callbackItem" />
    <!-- //업체 조회 -->
    <cust-pop ref="custPop"/>
    <!-- 협력사 사용자 조회-->
    <cust-user-pop ref="custUserPop"/>
      <!-- 협력사 상세 사용자 조회-->
    <cust-user-detail-pop ref="custUserDetailPop"/>
    <!-- 개찰자 조회-->
    <bid-open-user-pop ref="bidOpenUserPop" @callbackFunc="callbackOpenUser"/>
    <!-- 낙찰자 조회-->
    <bidding-user-pop ref="biddingUserPop" @callbackFunc="callbackBiddingUser"/>
    <!-- 입찰관련 일반사용자 조회-->
    <bid-user-pop ref="bidUserPop" @callbackFunc="callbackUser"/>
  </div>
  <!-- //본문 -->
</template>
<style>
a + i {
  margin-left: 10px;
}
</style>
<script>
import BidPast from "../components/BidPast.vue";
import fileInput from "../../../../public/js/fileInput.js";
import cmmn from "../../../../public/js/common.js";
import ItemPop from "@/components/ItemPop.vue";
import CustPop from "@/modules/company/components/CustPop.vue";
import CustUserPop from "@/modules/company/components/CustUserPop.vue";
import CustUserDetailPop from "@/modules/company/components/CustUserDetailPop.vue";
import BidOpenUserPop from "@/modules/company/components/BidOpenUserPop.vue";
import BidUserPop from "@/modules/company/components/BidUserPop.vue";
import BiddingUserPop from "@/modules/company/components/BiddingUserPop.vue";
import Calendar from "@/components/Calendar.vue";

export default {
  name: "bidProgressInsert",
  components: {
    BidPast,
    ItemPop,
    CustPop,
    CustUserPop,
    CustUserDetailPop,
    BidOpenUserPop,
    BidUserPop,
    BiddingUserPop,
    Calendar,
  },
  watch: {
    bdAmt(newValue) {
      // 숫자 이외의 문자 제거 (숫자, 마이너스 기호만 허용)
      this.bdAmt = newValue.toString().replace(/[^\d-]/g, '');
      
      // 천 단위로 콤마 추가
      this.bdAmt = this.bdAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  },
  data() {
    return {
      result: {},
      bidContent: {
        biNo: "",
        biModeCode: "A",
        insModeCode: "1",
        succDeciMethCode: "1",
        createUserName: this.$store.state.loginInfo.userName,
        createUser: this.$store.state.loginInfo.userId,
        interrelatedCustCode: this.$store.state.loginInfo.custCode,
        matDept: null,
        matProc: null,
        matCls: null,
        amtBasis: 'VAT 별도',
        openAtt1 : '',
        openAtt1Code : '',
        openAtt2 : '',
        openAtt2Code : '',
      },

      bdAmt: '',

      custContent: [],
      fileContent: [],
      tableContent: [],
      datePart: "",
      timePart: "",
      datePart1: "",
      timePart1: "",
      datePart2: "",
      timePart2: "",
      userInfo: {
        custCode: "",
        userName: "",
        userId: "",
      },
      filek: [],
      minDate : new Date().toISOString().slice(0, 10),
      lotteDeptList: [],
      lotteProcList: [],
      lotteClsList: [],
      fileData : {}, // 내역방식 파일 등록할 때 첨부파일 데이터
      fileData2 : {}, // 대내용 첨부파일 데이터
      fileData3 : {}, // 대외용 첨부파일 데이터
      insFile : '',
      innerFile : '',
      outerFile : '',
      bidPlan : 'O',
      custUserInfo : [],
      custUserName : [],
      innerFiles : [],
      outerFiles : [],
    }; 
  },
  computed: {
    totalSum() {
      // 테이블 내 모든 행의 합계 계산
      return this.tableContent.reduce(
        (sum, val) => sum + ((Number(val.orderQty.replace(/,/g, '')) * Number(val.orderUc.replace(/,/g, '')) ) || 0),
        0
      );
    },
  },

  filters: {
    numberWithCommas(value) {
      // 숫자에 쉼표 추가하는 필터 정의
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    callbackItem(data) {
      this.bidContent.itemCode = data.itemCode;
      this.bidContent.itemName = data.itemName;
      this.$forceUpdate();
    },

    callbackCust(data) {//입찰참거업체 업체등록
      const existingCust = this.custContent.find(
        (item) => item.custCode === data.custCode
      );

      if (!existingCust) {
        this.custContent.push({
          biNo: this.bidContent.biNo,
          custCode: data.custCode,
          custName: data.custName,
        });
        this.$forceUpdate();
      } else {
        this.$swal({
          type: "warning",
          text: "이미 등록한 업체입니다.",
        });
      }

    },
    callbackOpenUser(data) {
      this.bidContent.estOpener = data.userName;
      this.bidContent.estOpenerCode = data.userId;
      this.bidContent.estBidder = data.userName;
      this.bidContent.estBidderCode = data.userId;
      this.$forceUpdate();
    },
    callbackBiddingUser(data) {
      this.bidContent.estBidder = data.userName;
      this.bidContent.estBidderCode = data.userId;
      this.$forceUpdate();
    },
    callbackUser({ data, buttonId }) {

      switch (buttonId) {
        case "gongoId":
          this.bidContent.gongoId = data.userName;
          this.bidContent.gongoIdCode = data.userId;
          break;
        case "openAtt1":
          this.bidContent.openAtt1 = data.userName;
          this.bidContent.openAtt1Code = data.userId;
          break;
        case "openAtt2":
          this.bidContent.openAtt2 = data.userName;
          this.bidContent.openAtt2Code = data.userId;
          break;
      }

      this.$forceUpdate();
    },

    callbackPastBid(data) {//과거입찰 가져오기에서 선택시

      this.result = data[0][0];

      const tableContent = data[1]
      if(tableContent.length > 0){//입찰정보
        this.tableContent = tableContent.map((item, idx) => {
          return { ...item, orderQty : item.orderQty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),orderUc: item.orderUc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')};
       });;
      }

      
      this.fileContent = data[2];//파일정보
      this.custContent = data[3];//지명경쟁인 경우 지명된 협력사 정보

      this.bidContent.biName = this.result.biName;
      this.bidContent.itemCode = this.result.itemCode;
      this.bidContent.itemName = this.result.itemName;
      this.bidContent.biModeCode = this.result.biModeCode;//입찰방식
      this.bidContent.bidJoinSpec = this.result.bidJoinSpec
      if (!this.result.biModeCode) this.bidContent.biModeCode = "A";//"A" - 지명경쟁, "B" - 일반경쟁

      if(this.bidContent.biModeCode == "A"){
        this.custUserInfo = data[4]
        if(this.custUserInfo.length >0){

          const custCodeUserName = this.custUserInfo.reduce((acc, userInfo) => {
          const custCode = acc.find(item => item.custCode === userInfo.custCode);

            if (custCode) {
              custCode.userName += ', ' + userInfo.userName;
            } else {
                acc.push({ custCode: userInfo.custCode, userName: userInfo.userName });
            }

              return acc;
            }, []);
        this.custUserName = custCodeUserName

        }
      }
      this.bidContent.specialCond = this.result.specialCond;
      /*this.datePart = ''this.result.spotDate.substring(0, 10);
      this.timePart = this.result.spotDate.substring(11, 16);*/
      this.bidContent.spotArea = this.result.spotArea;
      this.bidContent.succDeciMethCode = this.result.succDeciMethCode;
      this.bidContent.amtBasis = this.result.amtBasis;
      this.bidContent.payCond = this.result.payCond;
      this.bdAmt = this.result.bdAmt != null ? this.result.bdAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''

      /*this.datePart1 = this.result.estStartDate.substring(0, 10);
      this.timePart1 = this.result.estStartDate.substring(11, 16);
      this.datePart2 = this.result.estCloseDate.substring(0, 10);
      this.timePart2 = this.result.estCloseDate.substring(11, 16);*/
      this.bidContent.estOpener = this.result.estOpener;
      this.bidContent.estOpenerCode = this.result.estOpenerCode;
      this.bidContent.gongoId = this.result.gongoId;
      this.bidContent.gongoIdCode = this.result.gongoIdCode;
      this.bidContent.estBidder = this.result.estBidder
      this.bidContent.estBidderCode = this.result.estBidderCode
      this.bidContent.openAtt1 = this.result.openAtt1;
      this.bidContent.openAtt1Code = this.result.openAtt1Code;
      this.bidContent.openAtt2 = this.result.openAtt2;
      this.bidContent.openAtt2Code = this.result.openAtt2Code;
      this.bidContent.insModeCode = this.result.insModeCode;//내역방식
      this.bidContent.supplyCond = this.result.supplyCond
      if (!this.result.insModeCode) this.bidContent.insModeCode = "1";// "1" - 파일등록, "2" - 내역집적등록

      if (this.result.interrelatedCustCode === "02") {
        this.bidContent.matDept = this.result.matDept;
        this.bidContent.matProc = this.result.matProc;
        this.bidContent.matCls = this.result.matCls;
        this.bidContent.matFactory = this.result.matFactory;
        this.bidContent.matFactoryLine = this.result.matFactoryLine;
        this.bidContent.matFactoryCnt = this.result.matFactoryCnt;
      }

      const currentDate = new Date()
      let currentHours = currentDate.getHours()
      currentHours = currentHours < 10 ? '0' + currentHours : currentHours
      
      const hours = `${currentHours}:00`
      this.timePart = hours
      this.timePart1 = hours
      this.timePart2 = hours

      this.$forceUpdate();
      $("#bidPast").modal("hide");
    },

    selectBid(mode) {//입찰방식 확인창 선택시

      if (mode === "cancel") {
        if (this.bidContent.biModeCode === "A")
          this.bidContent.biModeCode = "B";
        else this.bidContent.biModeCode = "A";
      } else if (mode === "ok") {
        if (this.bidContent.biModeCode === "A") {
          this.bidContent.biModeCode = "A";
        } else {
          this.custContent = [];
          this.$forceUpdate();
        }
      }
      this.$forceUpdate();
      $("#bmGeneral").modal("hide");
    },

    selectIns(mode) {//내역방식 confirm 창 선택시
      if (mode === "cancel") {
        if (this.bidContent.insModeCode === "1")
          this.bidContent.insModeCode = "2";
        else this.bidContent.insModeCode = "1";
      } else if (mode === "ok") {
        if (this.bidContent.insModeCode === "1") {
          //this.bidContent.insModeCode = "1";
          this.tableContent = [];
        } else {
          this.insFile = ''
          //this.bidContent.insModeCode = "2";
          /*
          this.fileContent = this.fileContent.filter(function (item) {
            return item.fileFlag !== "k";
          });
          this.filek = [];
          */
          //document.querySelector("#preview").innerHTML = "";
        }
      }

      this.$forceUpdate();
      $("#bmFile").modal("hide");
    },

    removeCust(index,custCode) {
      this.custUserInfo = this.custUserInfo.filter(item => item.custCode != custCode)
      this.custUserName = this.custUserName.filter(item => item.custCode != custCode)
      this.custContent.splice(index, 1);
    },
    addEmptyRow() {
      const seq = this.tableContent.length + 1;

      this.tableContent.push({
        biNo: this.bidContent.biNo,
        name: "",
        ssize: "",
        orderQty: "",
        unitcode: "",
        orderUc: "",
        type: "I",
      });
      this.$forceUpdate();
    },
    deleteRow(index) {
      this.tableContent.splice(index, 1);
    },

    validationCheck() {
      if (!this.bidContent.biName || this.bidContent.biName === "") {
        this.$swal({ type: "warning", text: "입찰명을 입력해 주세요." })
        return false;
      }
      if (!this.bidContent.itemCode || this.bidContent.itemCode === "") {
        this.$swal({ type: "warning", text: "품목을 선택해 주세요." })
        return false;
      }
      if (!this.bidContent.biModeCode || this.bidContent.biModeCode === "") {
        this.$swal({ type: "warning", text: "입찰방식을 선택해 주세요." })
        return false;
      }
      if (!this.bidContent.bidJoinSpec || this.bidContent.bidJoinSpec === "") {
        this.$swal({ type: "warning", text: "입찰참가자격을 선택해 주세요." });
        return false;
      }
      if (!this.datePart) {
        this.$swal({ type: "warning", text: "현장설명일시 날짜를 선택해 주세요." });
        return false;
      }
      if (!this.timePart) {
        this.$swal({ type: "warning", text: "현장설명일시 시간을 선택해 주세요." });
        return false;
      }

      const inputDate = new Date(this.datePart + " " + this.timePart)

      const currentTime1 = new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Seoul"}));

      if (currentTime1 > inputDate) {
        this.$swal({ type: "warning", text: "현장설명일시는 현재 시간보다 큰 시간을 선택해야 합니다." });
          return false
      } 

      if (!this.bidContent.spotArea || this.bidContent.spotArea === "") {
        this.$swal({ type: "warning", text: "현장설명장소를 입력해 주세요." });
        return false;
      }
      if (!this.bidContent.succDeciMethCode || this.bidContent.succDeciMethCode === "") {
        this.$swal({ type: "warning", text: "낙찰자 결정방법을 선택해 주세요." })
        return false;
      }
      if (this.custContent.length === 0 && this.bidContent.biModeCode === "A") {
        this.$swal({ type: "warning", text: "입찰참가업체를 선택해 주세요." });
        return false;
      }

      const custCodes = this.custContent.map(content => content.custCode);

      const allCustCodesInUserInfo = custCodes.every(custCode => {
          return this.custUserInfo.some(userInfo => userInfo.custCode == custCode);
      });

      if(this.bidContent.biModeCode === "A" && !allCustCodesInUserInfo){
        
        this.$swal({ type: "warning", text: "협력사 사용자를 선택하지 않은 입찰참가업체가 있습니다.\n입찰참가업체 명을 클릭하여 협력사 사용자를 선택해 주세요." });
        return false
      }

      if (!this.bidContent.amtBasis || this.bidContent.amtBasis === "") {
        this.$swal({ type: "warning", text: "금액기준을 선택해 주세요." });
        return false;
      }
      if (this.bidContent.interrelatedCustCode == "02" 
          && (!this.bidContent.matDept || !this.bidContent.matProc || !this.bidContent.matCls)) {
          this.$swal({ type: "warning", text: "분류군을 입력해 주세요." });
        return false;
      }
      if (!this.datePart1 || this.datePart1 === "") {
        this.$swal({ type: "warning", text: "제출시작일시 날짜를 선택해 주세요." });
        return false;
      }
      if (!this.timePart1 || this.timePart1 === "") {
        this.$swal({ type: "warning", text: "제출시작일시 시간을 선택해 주세요." });
        return false;
      }
      if (!this.datePart2 || this.datePart2 === "") {
        
        this.$swal({ type: "warning", text: "제출마감일시 날짜를 선택해 주세요." });
        return false;
      }
      if (!this.timePart2 || this.timePart2 === "") {
        this.$swal({ type: "warning", text: "제출마감일시 시간을 선택해 주세요." });
        return false;
      }

      var startDateTime = new Date(`${this.datePart1}T${this.timePart1}`)
;     var closeDateTime = new Date(`${this.datePart2}T${this.timePart2}`);

      const closeDate = new Date(this.datePart2 + " " + this.timePart2)

      const currentTime = new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Seoul"}));

      if (currentTime > closeDate) {
        this.$swal({ type: "warning", text: "제출마감일시는 현재 시간보다 큰 시간을 선택해야 합니다." });
          return false
      } 

      if (startDateTime > closeDateTime) {
        this.$swal({ type: "warning", text: "제출시작일시가 제출마감일시보다 큽니다." });
        return false;
      }

      this.bidContent.spotDate = this.datePart + " " + this.timePart;
      this.bidContent.estStartDate = this.datePart1 + " " + this.timePart1;
      this.bidContent.estCloseDate = this.datePart2 + " " + this.timePart2;
  
      if (!this.bidContent.estOpener || this.bidContent.estOpener === "") {
        this.$swal({ type: "warning", text: "개찰자를 선택해 주세요." });
        return false;
      }

      if (!this.bidContent.gongoId || this.bidContent.gongoId === "") {
        this.$swal({ type: "warning", text: "입찰공고자를 선택해 주세요." });
        return false;
      }

      if (!this.bidContent.estBidder || this.bidContent.estBidder === "") {
        this.$swal({ type: "warning", text: "낙찰자를 선택해 주세요." });
        return false;
      }

      if (!this.bidContent.supplyCond || this.bidContent.supplyCond === "") {
        this.$swal({ type: "warning", text: "납품조건을 입력해 주세요." });
        return false;
      }

      //세부내역 내역집적등록인 경우
      if (this.bidContent.insModeCode === "2") {
        if (this.tableContent.length === 0) {
          this.$swal({ type: "warning", text: "세부내역을 추가해 주세요." });
          return false;
        } else if(this.tableContent.length > 0){
          
          const nameCheck = this.tableContent.filter(item=> item.name == '')
          const ssizeCheck = this.tableContent.filter(item=> item.ssize == '')
          const unitcodeCheck = this.tableContent.filter(item=> item.unitcode == '')
          const orderUcCheck = this.tableContent.filter(item=> item.orderUc == '')
          const orderQtyCheck = this.tableContent.filter(item=> item.orderQty == '')

          if(nameCheck.length > 0){
            this.$swal({ type: "warning", text: "세부내역 품목명을 작성해 주세요." });
            return false;
          }
          if(ssizeCheck.length > 0){
            this.$swal({ type: "warning", text: "세부내역 규격을 작성해 주세요." });
            return false;
          }
          if(unitcodeCheck.length > 0){
            this.$swal({ type: "warning", text: "세부내역 단위를 작성해 주세요." });
            return false;
          }
          if(orderUcCheck.length > 0){
            this.$swal({ type: "warning", text: "세부내역 예정단가를 작성해 주세요." });
            return false;
          }
          if(orderQtyCheck.length > 0){
            this.$swal({ type: "warning", text: "세부내역 수량을 작성해 주세요." });
            return false;
          }

        }

      }

      //세부내역 파일등록 경우
      if (this.bidContent.insModeCode === "1") {
        if (this.insFile == '') {
          this.$swal({ type: "warning", text: "세부내역파일을 업로드 해 주세요." });
          return false;
        }
      }

      return true;
    },
    save() {
      var vm = this;
 
      //insert 전에 숫자에 천단위로 있는 콤마 제거
      this.bidContent.bdAmt = this.bdAmt.replace(/[^\d-]/g, '');
      let custContent = {}
      let updateEmail = {}
      if (this.bidContent.biModeCode === "A") {
          //등록되는 입찰 bino로 set
          custContent = this.custContent;
          
          custContent.forEach(function(element) {
              element.biNo = vm.bidContent.biNo;
          })
          updateEmail = {
            biNo: this.bidContent.biNo,
            type: "insert",
            interCd: this.bidContent.interrelatedCustCode,
          }
          this.bidContent.custCode = custContent.map(item => item.custCode).join(',')

          const custUserInfoFilter = {};

          this.custUserInfo.forEach(info => {

              if (!custUserInfoFilter[info.custCode]) {

                custUserInfoFilter[info.custCode] = '';
              } else {

                custUserInfoFilter[info.custCode] += ',';
              }

              custUserInfoFilter[info.custCode] += info.userId;
          });


          const custUserInfo = Object.keys(custUserInfoFilter).map(custCode => ({
              custCode: custCode,
              usemailId: custUserInfoFilter[custCode]
          }));
          
          this.bidContent.custUserInfo = custUserInfo

      }
      let tableContent = []
      //내역방식
      if(this.bidContent.insModeCode === "2") {//내역직접등록
        tableContent= this.tableContent.map((item, idx) => {
          return { ...item, seq: idx + 1, orderQty : Number(item.orderQty.replace(/,/g, '')),orderUc: Number(item.orderUc.replace(/,/g, ''))}
       });
      }

      let fd = new FormData()
      if(this.bidContent.insModeCode === "1"){
        fd.append("insFile", this.insFile)
      }

      if(this.innerFiles.length > 0){
        this.innerFiles.forEach(file => {
          fd.append("innerFiles", file)
        })
      }
      if(this.outerFiles.length > 0){
        this.outerFiles.forEach(file => {
          fd.append("outerFiles", file)
        })
      }

      this.bidContent.userId = this.userInfo.userId
      const params = {
        bidContent : this.bidContent,
        custContent : custContent,
        updateEmail : updateEmail,
        tableContent : tableContent,
      }
      fd.append("bidContent", JSON.stringify(params))

      

      this.$store.commit("loading");
      vm.$http.post("/api/v1/bid/insertBid", fd)
      .then((response) => {
          if (response.data.code == "OK") {
            $("#commonAlertMsg").html('저장되었습니다.');
            $("#commonAlertPop").modal("show"); 
            this.$router.push({ name: "bidProgress" });
            this.$store.commit("finish");
            return;
          }else if(response.data.code == "LOGOUT"){

            if (window.confirm("로그인 정보가 변경되었습니다.\n새로고침 하시겠습니까?")) {
              window.location.reload()
              $("#save").modal("hide")
              this.$store.commit("finish")
              window.scrollTo(0, 0)
            }else{
              $("#save").modal("hide")
              this.$store.commit("finish")
            }

          }else {
            this.$store.commit("finish");
            this.$swal({
              type: "warning",
              text: "저장 중 오류가 발생했습니다.",
            });
            return;
          }
      })

      /*
      this.$store.commit("loading");
      this.$http
        .post("/api/v1/bid/insertBid", this.bidContent)
        .then(async (response) => {
          //지명경쟁
          if (this.bidContent.biModeCode === "A") {
            //등록되는 입찰 bino로 set
            var custContent = this.custContent;
            custContent.forEach(function(element) {
                element.biNo = vm.bidContent.biNo;
            });

            //지명경쟁 협력사 등록
            await this.$http.post("/api/v1/bid/updateBidCust", custContent);

            //지명경쟁 협력사의 모든 대상자 이메일 insert
            await this.$http.post("/api/v1/bid/updateEmail", {
              biNo: this.bidContent.biNo,
              type: "insert",
              interCd: this.bidContent.interrelatedCustCode,
            });
          }

          //내역방식
          if (this.bidContent.insModeCode === "2") {//내역직접등록
            this.tableContent = this.tableContent.map((item, idx) => {
                return { ...item, seq: idx + 1 };
            });
            await this.$http.post("/api/v1/bid/updateBidItem", this.tableContent);
          }else if(this.bidContent.insModeCode === "1"){//파일등록
            this.sendFileContent();
          }  
          
          if (response.data.code == "OK") {
            this.$router.push({ name: "bidProgress" });
            this.$store.commit("finish");
          } 
          else {
            this.$swal({
              type: "warning",
              text: "수정 중 오류가 발생했습니다.",
            });
          }
          */




        /*

        }).catch((error) => {
          console.error(error);
          this.$swal({
              type: "warning",
              text: "수정 중 오류가 발생했습니다.",
          });
          this.$store.commit("finish");
        })
        .finally(() => {
          $("#save").modal("hide");
          this.$store.commit("finish");
        });
        */
    },
    async newBiNo() {//새로추가할 bino 가져오기
      this.$http
        .post("/api/v1/bid/newBiNo")
        .then((response) => {
          this.bidContent.biNo = response.data;

        })
        .catch((error) => {
          console.error("Error fetching biNo:", error);
        });
    },

    movetolist() {//목록으로 이동
      this.$store.commit("searchParams", {});
      this.$router.push({ name: "bidProgress" });
    },

    sendFileContent() {//파일 업로드
      this.fileContent.forEach((fileData) => {
        const formData = new FormData();
        if(fileData.selectedFile != null && fileData.selectedFile != undefined && fileData.selectedFile != ''){
          // 파일과 데이터를 FormData에 추가
          formData.append("file", fileData.selectedFile); // 파일
          formData.append(
            "data",
            JSON.stringify({
              // 데이터
              biNo: fileData.biNo,
              fileFlag: fileData.fileFlag,
              fCustCode: fileData.fCustCode,
            })
          );
        
          this.$http.post("/api/v1/bid/updateBidFile", formData);
        }
        
      });
    },

    changeFile(event) {
      // 파일 사이즈 체크
      // if(this.checkFileSize()){
      // 	return false;
      // }


      let fileFlag = "";
      switch (event.target.id) {
        case "file-input":
          fileFlag = "K";
          break;
        case "file-input2":
          fileFlag = "0";
          break;
        case "file-input3":
          fileFlag = "1";
          break;
      }

      // 동일한 fileFlag를 가진 기존 파일 정보가 있는 경우 삭제
      this.fileContent = this.fileContent.filter(
        (fileData) => fileData.fileFlag !== fileFlag
      );

      // 새로운 파일 정보 추가
      if (event.target.id === "file-input") {
        this.fileData= {
          biNo: this.bidContent.biNo,
          fileFlag: "K",
          fCustCode: "0",
          selectedFile: event.target.files[0],
        }
        this.filek.push({
          selectedFile: event.target.files[0],
        });
      }
      if (event.target.id === "file-input2") {
        this.fileData2= {
          biNo: this.bidContent.biNo,
          fileFlag: "K",
          fCustCode: "0",
          selectedFile: event.target.files[0],
        }
        
      }
      if (event.target.id === "file-input3") {
        this.fileData3= {
          biNo: this.bidContent.biNo,
          fileFlag: "K",
          fCustCode: "0",
          selectedFile: event.target.files[0],
        }
      }
      this.$forceUpdate();

    },
    fnUpdateSpotDate(val) {
      this.datePart = val;
    },
    fnUpdateStartDate(val) {
      this.datePart1 = val;
    },
    fnUpdateCloseDate(val) {
      this.datePart2 = val;
    },
    limitText() {//특수조건 글자수 제한
      if (this.bidContent.specialCond.length > 400) {
          // 최대 길이 초과 시 입력을 막음
          this.bidContent.specialCond = this.bidContent.specialCond.slice(0, 400);
      }
    },
    initDetailFile(){//내역직접등록 라디오 버튼 클릭시 세부내역 파일 초기화
      var fileTag = document.getElementById('file-input'); // 파일 입력 태그 가져오기
      fileTag.value = ''; // 파일 값 초기화
    },
    openConfirm(){//저장 전 valid 체크 및 확인창 띄우기
      if (!this.validationCheck()) {
        $("#save").modal("hide");
        return false;
      }else{
        $("#save").modal("show");
      }
    },
    changeNumOrderQty(idx) {

      const inputValue = this.tableContent[idx].orderQty.replace(/\D/g, '')
      this.tableContent[idx].orderQty = inputValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    changeNumOrderUc(idx) {

      const inputValue = this.tableContent[idx].orderUc.replace(/\D/g, '');
      this.tableContent[idx].orderUc = inputValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    },
    fileInputChangeInsFile(event){//견적세부파일
      const fileData = event.target.files[0]
        if(fileData.size > 10485760){
          event.target.value = ''
          this.$swal({ type: "warning", text: "파일 크기는 최대 10MB까지입니다.\n파일 크기를 확인해 주세요." });
          return 
        }
        this.insFile = fileData
    },
    changeInnerFiles(files) {
        const fileList = event.target.files;

        for (let i = 0; i < fileList.length; i++) {
          const fileData = fileList[i];

          // Check file size
          if (fileData.size > 10485760) {
            event.target.value = '';

            this.$swal({ type: "warning", text: "파일 크기는 최대 10MB까지입니다.\n파일 크기를 확인해 주세요." });

            return;
          }
          this.innerFile.push(fileData);
        }
    },
    fileInputChangeInnerFile(event){//대내용파일
      const fileData = event.target.files[0]
        if(fileData.size > 10485760){
          event.target.value = ''
          this.$swal({ type: "warning", text: "파일 크기는 최대 10MB까지입니다.\n파일 크기를 확인해 주세요." });
          return 
        }
        this.innerFile = fileData
    },
    fileInputChangeOuterFile(event){//대외용파일
      const fileData = event.target.files[0]
        if(fileData.size > 10485760){
          event.target.value = ''
          this.$swal({ type: "warning", text: "파일 크기는 최대 10MB까지입니다.\n파일 크기를 확인해 주세요." });
          return 
        }
      this.outerFile = fileData
    },
    getCodeList(){
      const vm = this
      this.$http
        .post('/api/v1/bid/progressCodeList')
        .then((response) => {
          const data = response.data
          vm.lotteDeptList = data.filter(item => item.colCode == 'MAT_DEPT')
          vm.lotteProcList = data.filter(item => item.colCode == 'MAT_PROC') 
			    vm.lotteClsList	= data.filter(item => item.colCode == 'MAT_CLS')
        })
        .catch((error) => {
          console.log(err)
        this.$store.commit('finish');s
        });
    },
    openCustUserDetailPop(custCode){
      const vm = this

      let custUserInfo = vm.custUserInfo.filter(item => item.custCode == custCode)
      $('#custUserDetailPop').modal('show');
      this.$refs.custUserDetailPop.initModal(custCode,custUserInfo)
    },
    removeOpenAttCode(num){
      const vm = this
      if(num == '1'){
        vm.$set(vm.bidContent, 'openAtt1', '')
        vm.$set(vm.bidContent, 'openAtt1Code', '')
      }else{
        vm.$set(vm.bidContent, 'openAtt2', '')
        vm.$set(vm.bidContent, 'openAtt2Code', '')
      }
    },
    innerFilesHandleDrop(event) {
      event.preventDefault();

      const fileList = event.dataTransfer.files;

      if (this.innerFiles.length + fileList.length > 20) {
        event.target.value = '';
        this.$swal({ type: "warning", text: "대내용 파일은 최대 20개까지 추가 가능합니다." });
        return;
      }

      for (let i = 0; i < fileList.length; i++) {
        const fileData = fileList[i];

        if (fileData.size > 10485760) {
          event.target.value = '';
          this.$swal({ type: "warning", text: "파일 크기는 최대 10MB까지입니다.\n파일 크기를 확인해 주세요." });
          return; 
        }
      }

      for (let i = 0; i < fileList.length; i++) {
        this.innerFiles.push(fileList[i]);
      }
      event.target.value = ''

    },
    outerFilesHandleDrop(event) {
      event.preventDefault();

      const fileList = event.dataTransfer.files;

      if (this.outerFiles.length + fileList.length > 20) {
        event.target.value = '';
        this.$swal({ type: "warning", text: "대외용 파일은 최대 20개까지 추가 가능합니다." });
        return;
      }

      for (let i = 0; i < fileList.length; i++) {
        const fileData = fileList[i];

        if (fileData.size > 10485760) {
          event.target.value = '';
          this.$swal({ type: "warning", text: "파일 크기는 최대 10MB까지입니다.\n파일 크기를 확인해 주세요." });
          return; 
        }
      }

      for (let i = 0; i < fileList.length; i++) {
        this.outerFiles.push(fileList[i]);
      }

    },
    removeInnerFiles(idx){
      if(idx == 'ALL'){
        this.innerFiles = []
      }else{
        this.innerFiles.splice(idx,1)
      }
      
    },
    removeOuterFiles(idx){
      if(idx == 'ALL'){
        this.outerFiles = []
      }else{
        this.outerFiles.splice(idx,1)
      }
    },
    innerFilesPop(){
      this.$refs.innerFilesInput.click(); 
    },
    innerFilesClick(event){
      const fileList = event.target.files;

      if (this.innerFiles.length + fileList.length > 20) {
        event.target.value = '';
        this.$swal({ type: "warning", text: "대내용 파일은 최대 20개까지 추가 가능합니다." });
        return;
      }

      for (let i = 0; i < fileList.length; i++) {
        const fileData = fileList[i];

        if (fileData.size > 10485760) {
          event.target.value = '';
          this.$swal({ type: "warning", text: "파일 크기는 최대 10MB까지입니다.\n파일 크기를 확인해 주세요." });
          return; 
        }
      }

      for (let i = 0; i < fileList.length; i++) {
        this.innerFiles.push(fileList[i]);
      }
      event.target.value = ''
    },
    outerFilesPop(){
      this.$refs.outerFilesInput.click(); 
    },
    outerFilesClick(event){

      const fileList = event.target.files;

      if (this.outerFiles.length + fileList.length > 20) {
        event.target.value = '';
        this.$swal({ type: "warning", text: "대외용 파일은 최대 20개까지 추가 가능합니다." });
        return;
      }

      for (let i = 0; i < fileList.length; i++) {
        const fileData = fileList[i];

        if (fileData.size > 10485760) {
          event.target.value = '';
          this.$swal({ type: "warning", text: "파일 크기는 최대 10MB까지입니다.\n파일 크기를 확인해 주세요." });
          return; 
        }
      }

      for (let i = 0; i < fileList.length; i++) {
        this.outerFiles.push(fileList[i]);
      }
      event.target.value = ''
    },
  },
  beforeMount() {},
  mounted() {
    this.newBiNo();

    this.userInfo.custCode = this.$store.state.loginInfo.custCode;
    this.userInfo.userName = this.$store.state.loginInfo.userName;
    this.userInfo.userId = this.$store.state.loginInfo.userId;
    
    this.bidContent.gongoId = this.$store.state.loginInfo.userName;
    this.bidContent.gongoIdCode = this.$store.state.loginInfo.userId;

    //달력
    cmmn.applyCal();
    //파일첨부
    fileInput.applyFile();
    if(this.bidContent.interrelatedCustCode==='02'){
      this.getCodeList()
    }

    const currentDate = new Date()
    let currentHours = currentDate.getHours()
    currentHours = currentHours < 10 ? '0' + currentHours : currentHours
    
    const hours = `${currentHours}:00`
    this.timePart = hours
    this.timePart1 = hours
    this.timePart2 = hours

  },
};
</script>